<div class="row">
    <div class="card mt-4 dark-theme">
        <h4 class="card-header">Elemental courses</h4>
        <div class="card-body">
            <div *ngIf="loading1" class="spinner-border spinner-border-sm"></div>
            <div *ngIf="userData">
                <div>
                    Welcome, {{userData.userName}} !
                </div>
                <div>
                    {{userData.companyRol}},
                </div>
                <div>
                    <a href="#">{{userData.companyName}}</a>,
                </div>
                <div class="card mt-4 dark-theme">
                    You are a {{userData.elementalRol}}
                </div>
            </div>
        </div>
    </div>

    <div class="card mt-4 dark-theme">
        0 activities completed
    </div>
</div>
<div class="row">
    <div class="card mt-4 dark-theme">
        <h4 class="card-header">Your journey</h4>
        <div class="card-body">
            <div>
                Complete your getting started tasks:
            </div>
            <div *ngIf="loading2" class="spinner-border spinner-border-sm"></div>
            <div *ngIf="journeySteps">
                <div *ngFor="let journeyStep of journeySteps">{{journeyStep.name}}</div>
            </div>
            <div *ngIf="coursesProgress">
                <a *ngFor="let course of coursesProgress" [routerLink]="getContinuationLink(course)">{{course.courseName}}</a>
            </div>
        </div>
    </div>
</div>